module.exports = __webpack_public_path__ + "img/step_3-5.43918d14.png";